import { TemplateType } from "shared-utils/enums/masterTemplate";

import type { AeComputedOverwrite, ConstructedDeliverable, PlainlyLayerManagement } from "@/types/types";

import type { RequestRenderInput } from "./ae";

export default function computeAfterEffectsLayers(deliverables: ConstructedDeliverable[]) {
    const inputs = deliverables.reduce<RequestRenderInput[]>((acc, deliverable) => {
        if (deliverable.masterTemplate.adType !== TemplateType.AE) {
            return acc;
        }

        const computedOverwrites = deliverable.computedValues.map(
            ({ value, name, type, settings }): AeComputedOverwrite => ({
                value,
                name,
                type: type as AeComputedOverwrite["type"],
                settings
            })
        );

        computedOverwrites.forEach(computedOverwrite => {
            const settings = computedOverwrite.settings;

            if (!settings) {
                return;
            }

            const layerManagement = {
                ...(settings.fontSize ? { fontSize: Number(settings.fontSize) } : {}),
                ...(settings.font ? { font: settings.font } : {})
            };

            if (layerManagement.fontSize || layerManagement.font) {
                computedOverwrite.layerManagement = layerManagement as PlainlyLayerManagement;
            }
        });

        acc.push({
            reportingLabel: deliverable.reportingLabel,
            aeInfo: deliverable.masterTemplate.aeInfo,
            computedOverwrites
        });

        return acc;
    }, []);

    return inputs;
}
